<div class="section-gap pt-3 pb-0 mb-4">
  <div class="swiper-container home-2-slider"
    [ngClass]="{
      'pt-4': environmentVariables?.SLIDER_THEME_TYPE == 'container'
    }">
    <swiper [config]="swiperConfig" dir="ltr" class="mySwiper" #bannerSwiper>
      <ng-template swiperSlide *ngFor="let slide of AdsSlidersArray; let i = index" class="swiper-slide">
        <ng-container>
          <a class="relative" (click)="onSlideClick(slide); setG4AClickCarousel(slide, i)"
            [ngClass]="{'with-left' : environmentVariables?.SLIDER_THEME_TYPE == 'container' && lang == 'en' }"
          >
            <img  
              loading="lazy"  
              default="./assets/images/placeholder200.jpg"
              onError="this.src='./assets/images/placeholder200.jpg';this.style='object-fit: scale-down;'"
              [ngClass]="{ 'pointer': slide.type !== 0  }"
              [src]="slide.image_web" 
              class="hidden-in-mobile"    
              alt="slide image" 
            />
            <img  
              loading="lazy"  
              default="./assets/images/placeholder200.jpg"
              onError="this.src='./assets/images/placeholder200.jpg';this.style='object-fit: scale-down;'"
              [ngClass]="{ 'pointer': slide.type !== 0}"
              [src]="slide.image"
              class="show-in-mobile"    
              [alt]="slide.image" 
            />
          </a>
        </ng-container>
   
      </ng-template>
    </swiper>
  </div>
</div>
